import type { DataOrigin } from "@/api";
import type { ReservedSelections } from "@/components/label";

/**
 * 새 업로드 폼이 미리 고르는 값. 환경 Real, 출처 내부, 행동 주체 Human demo 다(product 결정, 2026-08-27).
 *
 * 지금은 FE 가 이 값을 묵시적으로 채운다. 이유는 다음과 같다.
 * - 예약 라벨 계약(GET /v1/label-reserved-keys)의 `default` 는 창이 열린 뒤에 도착한다. 그래서
 *   이미 그린 폼에 적용되지 않는다.
 * - 행동 주체는 기본값 계약이 없다.
 * 서버가 세 필드의 기본값을 보내면(ZERG-474) 이 모듈이 그 계약을 소비한다. 값을 읽는
 * 코드(컨트롤러, 테스트)는 이 모듈만 본다.
 *
 * 재업로드·이어받기 폼은 서버 저장값만 pre-fill 로 쓴다. 그래서 이 값을 쓰지 않는다.
 */
export type UploadFormDefaults = {
  reservedSelections: ReservedSelections;
  dataOrigin: DataOrigin;
};

export const UPLOAD_FORM_DEFAULTS: UploadFormDefaults = {
  reservedSelections: { environment: ["real"], source: ["internal"] },
  dataOrigin: "human_demonstration",
};
